<p-dialog
  [(visible)]="visible"
  [modal]="modal"
  [closable]="closable"
  [closeOnEscape]="closeOnEscape"
  [dismissableMask]="dismissableMask"
  [draggable]="draggable"
  [resizable]="resizable"
  [maximizable]="maximizable"
  [appendTo]="appendTo"
  [style]="dialogStyle"
  [styleClass]="dialogStyleClass"
  [blockScroll]="blockScroll"
  [showHeader]="showHeader"
  (onShow)="onDialogShow()"
  (onHide)="onDialogHide()"
  (onMaximize)="onDialogMaximize($event)"
  (visibleChange)="onVisibleChange($event)"
>
  <!-- Header Template -->
  <ng-template pTemplate="header">
    <ng-container *ngIf="headerTemplate; else defaultHeader">
      <ng-container *ngTemplateOutlet="headerTemplate"></ng-container>
    </ng-container>
    <ng-template #defaultHeader>
      <div class="vb-dialog__header">
        <span class="vb-dialog__title">{{ header }}</span>
        <span *ngIf="subHeader" class="vb-dialog__subtitle">{{ subHeader }}</span>
      </div>
    </ng-template>
  </ng-template>

  <!-- Content -->
  <div class="vb-dialog__content">
    <ng-content></ng-content>
  </div>

  <!-- Footer Template -->
  <ng-template pTemplate="footer" *ngIf="footerTemplate">
    <ng-container *ngTemplateOutlet="footerTemplate"></ng-container>
  </ng-template>
</p-dialog>
